<template lang="pug">
  div
    .layout-view__controls(v-if="hasPermission('additional', 'add')")
      v-btn(
        medium
        @click="modal.showCreate = true")
        v-icon(
          position-left
          font-size="1"
          icon="plus").mr-1
        span {{ 'base.add_blank' | translate }}
    v-dialog(
      max-width="650"
      v-model="modal.showCreate")
      create-modal(
        @close="modal.showCreate = false")
    v-dialog(
      max-width="650"
      :value="showEditAdditional"
      @input="closeAdditional")
      edit-modal
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import CreateModal from './modals/CreateModal'
import EditModal from './modals/EditModal'

export default {
  name: 'ControlsPanel',

  components: {
    CreateModal,
    EditModal
  },

  data: () => ({
    modal: {
      showCreate: false
    }
  }),

  computed: {
    ...mapGetters('additional', [
      'currentAdditional'
    ]),

    showEditAdditional () {
      return !!this.currentAdditional
    },
  },

  methods: {
    ...mapActions('additional', [
      'closeAdditional'
    ])
  }
}
</script>
